module.exports = __webpack_public_path__ + "img/close12.e26c0d69.png";